import '../src/style.css'
import './gradient-animations';
import './menu-navigations';
import './chat-widget';
/**
 * Globird Energy Child Theme Script
 *
 * @since 1.0.0
 */
(function ($) {
  // Scroll Up to the top.
  $.scrollUp({
    scrollDistance: 100,
    scrollTitle: false,
    scrollImg: true,
  });

  // Image Animation
  $.fn.visible = function (partial) {
    var $t = $(this),
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;

    return compareBottom <= viewBottom && compareTop >= viewTop;
  };

  $(window).scroll(function (event) {
    $(".module").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("come-in");
      }
    });
  });

  var win = $(window);
  var allMods = $(".image-wrapper img");

  // Already visible modules
  allMods.each(function (i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("already-visible");
    }
  });

  win.scroll(function (event) {
    allMods.each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("come-in");
      }
    });
  });

  var $blocks = $(".animBlock.notViewed");
  var $window = $(window);

  $window.on("scroll", function (e) {
    $blocks.each(function (i, elem) {
      if ($(this).hasClass("viewed")) return;

      isScrolledIntoView($(this));
    });
  });

  /* http://stackoverflow.com/a/488073/477958 */
  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemOffset = 0;

    if (elem.data("offset") != undefined) {
      elemOffset = elem.data("offset");
    }
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    if (elemOffset != 0) {
      // custom offset is updated based on scrolling direction
      if (docViewTop - elemTop >= 0) {
        // scrolling up from bottom
        elemTop = $(elem).offset().top + elemOffset;
      } else {
        // scrolling down from top
        elemBottom = elemTop + $(elem).height() - elemOffset;
      }
    }

    if (elemBottom <= docViewBottom && elemTop >= docViewTop) {
      // once an element is visible exchange the classes
      $(elem).removeClass("notViewed").addClass("viewed");

      var animElemsLeft = $(".animBlock.notViewed").length;
      if (animElemsLeft == 0) {
        // with no animated elements left debind the scroll event
        // $(window).off('scroll');
      }
    }
  }

  var mql = window.matchMedia("(min-width: 1024px)");
  if (mql.matches) {
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 100) {
        $(".site-header").addClass("is-sticky");
      } else {
        $(".site-header").removeClass("is-sticky");
      }
    });
  }

  // Enable Bootstrap Tooltip
  var dataToolTip = $('[data-toggle="tooltip"]');
  if(dataToolTip) {
    dataToolTip.tooltip();
  }

  // Function in /legal/flexible page. will name this function properly later.
  var url = document.location;
  var urlHash = url.hash.match(/(#)\w+/g);

  const tabState = document.querySelector("#tabState");
  if (tabState) {
    if (urlHash) {
      $('.nav-tabs a[href="' + urlHash + '"]').tab("show");
    }
  }

  const accordionState = document.querySelector("#collapse-9");
  if (accordionState) {
    // var urlHash = url.hash.match(/(#\-)\w*/g);
    var urlHash = url.hash;
    if (urlHash) {
      const dataTarget = document.querySelector(
        'button[data-target="#collapse-9"]'
      );
      dataTarget.click().scrollIntoView();
    }
  }

  // Ratings
  const ratingValues = document.querySelectorAll('input[name="rating"]');
  if (ratingValues) {
    ratingValues.forEach(function (ratingValue) {
      ratingValue.addEventListener("click", function (event) {
        const value = ratingValue.defaultValue;
        switch (value) {
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
            window.location = "/feedback1/";
            break;
          case "6":
          case "7":
            window.location =
              "https://www.productreview.com.au/listings/globird-energy";
            break;
          case "8":
          case "9":
            window.location =
              "https://www.google.com/search?rlz=1C5CHFA_enAU705AU705&ei=HtG1XK3sK4X9rQH07L64Dg&q=globird+energy+review&oq=globird&gs_l=psy-ab.1.2.0i131j0l9.3038.5157..7093...0.0..0.369.1374.0j6j0j1......0....1..gws-wiz.......0i71j0i131i67j0i67.4bKo4gehi24#lrd=0x6ad6397d44021fa3:0xa7669918efcb7aa2,1,,,%60";
            break;
          default:
            break;
        }
      });
    });
  }

  const customerReview = document.querySelector(".splide--customer-reviews");
  if (customerReview) {
    new Splide(customerReview, {
      type: "loop",
      perPage: 3,
      pagination: false,
      gap: 44,
      breakpoints: {
        768: {
          perPage: 2,
          arrows: false,
        },
        640: {
          perPage: 1,
        },
      },
    }).mount();
  } 

  
})(jQuery);

document.addEventListener("alpine:init", () => {
  Alpine.data("tabs", () => ({
    open: 4,
    trigger: {
      ["@click.prevent"](id) {
        this.open = id;
      },
    },
    open: {
      ["open"]() {
        return this.open;
      },
    },
  }));
});